import React from 'react'

import Layout from '../components/Layout'
import Text from '../components/Text'
import Button from '../components/Button'
import ActionBar from '../components/ActionBar'

export default ({ onNext }) => {
  return (
    <Layout>
      <Layout>
        <Layout>
          <Text huge bold>
            HELP US FIGHT THE CORONAVIRUS
          </Text>
        </Layout>

        <Layout>
          <Text>
            To ease up people's anxiety and facilitate medical responses in the current COVID
            pandemic crisis, <strong>the VoiceMed team</strong> is developing a voice-based
            diagnosis utilising AI that could differentiate a healthy person from an infected one by
            listening to their voice.
          </Text>
        </Layout>

        <Layout>
          <Text>
            Your help is essential in training our algorithm. We need you to record your voice by
            repeating a sentence and do some breathing tests.
          </Text>
        </Layout>

        <Layout>
          <Text>
            The recording is confidential and anonymous. The process takes no more than 2 minutes of
            your time.
          </Text>
        </Layout>

        <Layout highlight>
          <Text>
            Please notice that in-app browsers (such as Facebook) are not supported
          </Text>
        </Layout>
      </Layout>

      <ActionBar active>
        <Layout />
        <Button onClick={onNext}>Start</Button>
      </ActionBar>
    </Layout>
  )
}
